// extracted by mini-css-extract-plugin
export var dropdownContainer = "_la-0";
export var leftAlign = "_la-4";
export var listItem = "_la-2";
export var listItemWrapper = "_la-1";
export var operationText = "_la-3";